import staticContent from './staticContent.json';

export default staticContent;
